// useState key for the app-platform header forwarded from the native app's
// webview. Set by the SSR plugin (forwardedAppPlatform.server.ts) from the
// incoming request header, available on the client via hydration.
export const FORWARDED_APP_PLATFORM_STATE_KEY = 'forwarded-app-platform'
